import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { usersGraphqlService, UserGroupAuditLog } from '@/services/api/users/usersGraphqlService';
import { useErrorHandler } from '@/hooks/useErrorHandler';

export const useUserGroupAuditLog = (userGroupId: number | null) => {
  const { hasuraToken } = useAuth();
  const { handleError } = useErrorHandler();
  const [auditLogs, setAuditLogs] = useState<UserGroupAuditLog[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!hasuraToken || !userGroupId) {
        setAuditLogs([]);
        return;
      }

      setLoading(true);
      try {
        const result = await usersGraphqlService.getUserGroupAuditLog(hasuraToken, userGroupId);
        
        if (result.success && result.data) {
          setAuditLogs(result.data.pep_user_group_audit_log || []);
        } else {
          handleError(result.errors?.[0] || 'Failed to fetch audit logs');
          setAuditLogs([]);
        }
      } catch (err) {
        handleError(err, 'Error fetching audit logs');
        setAuditLogs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAuditLogs();
  }, [hasuraToken, userGroupId, handleError]);

  return { auditLogs, loading };
};
